export const ADDED_PRODUCT_POPUP_ID = 'added-product-popup';
export const SHOW_PAIR_OPTION = 'show_pair_option';
